export default __webpack_public_path__ + "static/media/alexa.5f52ba42.jpg";